// extracted by mini-css-extract-plugin
export default {"body":"PricelistFormModal__body___v1bw1","error":"PricelistFormModal__error___M3zkD","footer":"PricelistFormModal__footer___XtlAO"};